import React from "react";

export function Crest({ size = 34, color = "#211D18", accent = "#B08D57" }) {
  return (
    <svg height={size} viewBox="8 4 84 118" fill="none" aria-hidden="true" style={{ display: "block" }}>
      <g strokeLinecap="round" strokeLinejoin="round">
        <path d="M14,12 L86,12 L86,54 C86,84 68,104 50,116 C32,104 14,84 14,54 Z" fill="none" stroke={color} strokeWidth="3.2" />
        <path d="M14,12 L86,12 L86,54 C86,84 68,104 50,116 C32,104 14,84 14,54 Z" fill="none" stroke={accent} strokeWidth="1" transform="translate(50,64) scale(0.88) translate(-50,-64)" />
        <line x1="27" y1="70" x2="73" y2="70" stroke={color} strokeWidth="2" />
        <path d="M35,70 A15,15 0 0 1 65,70 Z" fill={accent} />
        <line x1="63.8" y1="58.4" x2="70.7" y2="52.6" stroke={accent} strokeWidth="2.3" />
        <line x1="57.6" y1="53.7" x2="61.4" y2="45.5" stroke={accent} strokeWidth="2.3" />
        <line x1="50" y1="52" x2="50" y2="43" stroke={accent} strokeWidth="2.3" />
        <line x1="42.4" y1="53.7" x2="38.6" y2="45.5" stroke={accent} strokeWidth="2.3" />
        <line x1="36.2" y1="58.4" x2="29.3" y2="52.6" stroke={accent} strokeWidth="2.3" />
        <line x1="34" y1="80" x2="66" y2="80" stroke={accent} strokeWidth="1.9" />
        <line x1="39" y1="89" x2="61" y2="89" stroke={accent} strokeWidth="1.6" />
        <line x1="43.5" y1="98" x2="56.5" y2="98" stroke={accent} strokeWidth="1.4" />
      </g>
    </svg>
  );
}

export function Brandmark({ size = 34, light = false, fontSize = 27, tagline = false, tagText = "SOLVANA GROUP" }) {
  const gold = "#C79A4B";
  const crestColor = light ? "#D9C08A" : "#211D18";
  const wordColor = light ? "#FBF8F2" : "#211D18";
  const tagColor = light ? "#cbb98f" : "var(--muted)";
  return (
    <span style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <Crest size={size} color={crestColor} />
      <span style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
        <span className="font-serif-c" style={{ fontSize, fontWeight: 500, letterSpacing: ".26em", paddingLeft: ".26em", color: wordColor }}>
          SOLVANA
        </span>
        <span style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 8 }}>
          <span style={{ height: 1, flex: 1, background: gold }} />
          <span style={{ width: 5, height: 5, background: gold, transform: "rotate(45deg)", flexShrink: 0 }} />
          <span style={{ height: 1, flex: 1, background: gold }} />
        </span>
        {tagline && (
          <span className="fade-up" style={{ fontSize: Math.max(8, fontSize * 0.3), textTransform: "uppercase", letterSpacing: ".16em", color: tagColor, marginTop: 7, textAlign: "center", whiteSpace: "nowrap" }}>
            {tagText}
          </span>
        )}
      </span>
    </span>
  );
}
